/* modal-lead.js — extracted from index.html */
(function(){
  var modal = document.getElementById('leadModal');
  if(!modal) return;
  var titleEl = document.getElementById('leadModalTitle');
  var subEl = document.getElementById('leadModalSub');
  var eyebrowEl = document.getElementById('leadModalEyebrow');
  var sourceEl = document.getElementById('lm-source');
  var form = document.getElementById('leadModalForm');
  var successEl = document.getElementById('leadModalSuccess');
  var submitBtn = form ? form.querySelector('.modal-submit') : null;

  var presets = {
    quote: {
      eyebrow: '⚡ Quick response',
      title: 'Get a fixed-fee quote',
      sub: 'Tell us about your project. We’ll reply within 24 hours with a written proposal, fixed-fee quote, and a clear timeline.',
      cta: 'Request my quote →'
    },
    audit: {
      eyebrow: '★ 48-hour turnaround',
      title: 'Get a free project audit',
      sub: 'Send your URL and we’ll record an 8-min Loom with 5 prioritized growth opportunities: no commitment, no sales pitch.',
      cta: 'Send me my audit →'
    }
  };

  function openModal(type){
    var p = presets[type] || presets.audit;
    eyebrowEl.textContent = p.eyebrow;
    titleEl.textContent = p.title;
    subEl.innerHTML = p.sub;
    if(submitBtn) submitBtn.textContent = p.cta;
    sourceEl.value = type;
    form.style.display = '';
    successEl.classList.remove('is-shown');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('modal-locked');
    setTimeout(function(){
      var first = modal.querySelector('input,select,textarea');
      if(first) first.focus();
    }, 240);
  }
  function closeModal(){
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('modal-locked');
  }

  document.addEventListener('click', function(e){
    var opener = e.target.closest('[data-modal-open]');
    if(opener){
      e.preventDefault();
      openModal(opener.getAttribute('data-modal-open'));
      return;
    }
    if(e.target.matches('[data-modal-close]') || e.target === modal){
      closeModal();
    }
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Submission is owned by assets/js/forms.js, which only shows success after
  // the server confirms it. A "demo-friendly" handler used to live here: it
  // swallowed the submit, hid the form and showed the success panel, so the
  // quote and audit modals reported success while discarding every lead.
  // forms.js calls this when a real 2xx comes back.
  window.__leadModalSuccess = function(){
    if(!form || !successEl) return;
    form.style.display = 'none';
    successEl.classList.add('is-shown');
    setTimeout(function(){
      closeModal();
      setTimeout(function(){ form.reset(); form.style.display = ''; successEl.classList.remove('is-shown'); }, 260);
    }, 2600);
  };
})();
